// This component, in general, is responsible for displaying icons over frame shapes (shapes with background colors).
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SpriteIcon from "orion-components/SharedComponents/SpriteIcon/SpriteIcon";

const IconFrameOverlay = ({ icon, frameDimensions, iconDimensions, color, shape, forMap, dashed, customStyles }) => {
	const [frameShape, setFrameShape] = useState(null);

	// This useEffect hook constructs the frame key based on shape, color, map, and dashed properties, and updates the frame shape accordingly.
	useEffect(() => {
		const frameKey = `frame_${shape}${dashed ? "_dashed" : ""}${forMap ? "_map" : ""}_${color}`;
		if (global.OC_spriteData[frameKey]) {
			setFrameShape(frameKey);
		}
	}, [color, shape, forMap, dashed]);

	if (frameShape !== null) {
		return (
			<div style={customStyles}>
				<span style={{ position: "relative", display: "inline-block" }}>
					<SpriteIcon
						iconName={frameShape}
						customWidth={frameDimensions.width}
						customHeight={frameDimensions.height}
					/>
					<span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
						<SpriteIcon
							iconName={icon}
							customWidth={iconDimensions.width}
							customHeight={iconDimensions.height}
						/>
					</span>
				</span>
			</div>
		);
	}
	return <></>;
};

IconFrameOverlay.propTypes = {
	icon: PropTypes.string.isRequired,
	frameDimensions: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	iconDimensions: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	color: PropTypes.string,
	shape: PropTypes.string,
	forMap: PropTypes.bool,
	dashed: PropTypes.bool
};

IconFrameOverlay.defaultProps = {
	frameDimensions: { width: 30, height: 30 },
	iconDimensions: { width: 30, height: 30 },
	forMap: false,
	dashed: false
};

export default IconFrameOverlay;
